import styles from "./add-remarks-modal.module.scss";
import locale from "localization";
import { TextField } from "components/commons";
import { ConfirmModal } from "components/modals";
import { useEffect, useState } from "react";
import { FormMode } from "enums";

const AddRemarksTotalizerModal = ({ remarks, handleSave, pageMode, ...modal }) => {
  const [value, setValue] = useState("");
  const handleInputChange = (name, { value }) => {
    setValue?.(value);
  };

  const isEdited = remarks !== value;
  const isView = pageMode === FormMode.View;

  useEffect(() => {
    if (modal.active) {
      setValue(remarks);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modal.active]);

  return (
    <ConfirmModal
      {...modal}
      title={isView ? locale.viewRemarks : remarks ? locale.editRemarks : locale.addRemarks}
      hideSecondary={isView}
      titleStyle={styles.content}
      primary={{
        text: isView ? locale.gotIt : locale.save,
        onClick: () => {
          if (!isView) {
            handleSave?.(value);
          }
          setValue("");
          modal.close();
        },
        disabled: !isEdited && !isView,
      }}
      secondary={{
        text: locale.cancel,
        onClick: () => {
          setValue("");
          modal.close();
        },
      }}
    >
      <div className={styles.form}>
        <TextField
          multiline
          placeholder={locale.sampleRemarksHere}
          maxLength={300}
          value={value}
          onChange={handleInputChange}
          disabled={isView}
          inputDisabled={isView}
        />
      </div>
    </ConfirmModal>
  );
};

export default AddRemarksTotalizerModal;
